import Vue from 'vue';
import Router, { RouteConfig } from 'vue-router';
import Dashboard from './views/Dashboard.vue';
import Login from './views/Login.vue';
import Users from './views/Users.vue';
import Roles from './views/Roles.vue';
import Warehouses from './views/Warehouses.vue';
import Good from './views/Goods.vue';
import Companies from './views/Companies.vue';
import Customers from './views/Customers.vue';
import Inbounds from './views/Inbounds.vue';
import Outbounds from './views/Outbounds.vue';
import InboundsShared from './views/InboundsShared.vue';
import OutboundsShared from './views/OutboundsShared.vue';
import Stock from './views/Stock.vue';
import Settings from './views/Settings.vue';
import Movement from './views/Movements.vue';
import NoticeOfLoss from './views/NoticeOfLoss.vue';
import Dossiers from './views/Dossiers.vue';
import Planning from './views/Planning.vue';
import Printing from './views/Printing.vue';
import CustomerStock from './views/CustomerStock.vue';
import CustomerDashboard from './views/CustomerDashboard.vue';
import CompanySettings from './views/CompanySettings.vue';
import Reports from './views/Reports.vue';
import Transformations from './views/Transformations.vue';
import Sells from './views/Sells.vue';
import Logs from './views/Logs.vue';
Vue.use(Router);

export const routes : RouteConfig[] = [
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
            desc: 'Login',
            icon: 'fa-sign-in'
        }
    }, {
        path: '/',
        name: 'Dashboard',
        component: Dashboard,
        meta: {
            desc: 'Dashboard',
            icon: 'fa-area-chart'
        }
    }, {
        path: '/CustomerDashboard',
        name: 'CustomerDashboard',
        component: CustomerDashboard,
        meta: {
            desc: 'Customer Dashboard',
            icon: 'fa-folder-open-o'
        }
    }, {
        path: '/Companies',
        name: 'Companies',
        component: Companies,
        meta: {
            desc: 'Companies',
            icon: 'fa-building-o'
        }
    }, {
        path: '/Customers',
        name: 'Customers',
        component: Customers,
        meta: {
            desc: 'Customers',
            icon: 'fa-user'
        }
    }, {
        path: '/CustomerStock',
        name: 'CustomerStock',
        component: CustomerStock,
        meta: {
            desc: 'Customer Stock',
            icon: 'fa-address-card'
        }
    }, {
        path: '/Warehouses',
        name: 'Warehouses',
        component: Warehouses,
        meta: {
            desc: 'Warehouses',
            icon: 'fa-cubes'
        }
    }, {
        path: '/Goods',
        name: 'Goods',
        component: Good,
        meta: {
            desc: 'Goods',
            icon: 'fa-shopping-basket'
        }
    }, {
        path: '/Stock',
        name: 'Stock',
        component: Stock,
        meta: {
            desc: 'Stock',
            icon: 'fa-list-alt'
        }
    }, {
        path: '/Dossiers',
        name: 'Dossiers',
        component: Dossiers,
        meta: {
            desc: 'Dossiers',
            icon: 'fa-archive'
        }
    }, {
        path: '/Movements',
        name: 'Movements',
        component: Movement,
        meta: {
            desc: 'Movements',
            icon: 'fa-exchange'
        }
    }, {
        path: '/Inbounds',
        name: 'Inbounds',
        component: Inbounds,
        meta: {
            desc: 'Inbounds',
            icon: 'fa-arrow-circle-down'
        }
    }, {
        path: '/InboundsShared',
        name: 'InboundsShared',
        component: InboundsShared,
        meta: {
            desc: 'Inbounds Shared',
            icon: 'fa-object-group '
        }
    }, {
        path: '/Outbounds',
        name: 'Outbounds',
        component: Outbounds,
        meta: {
            desc: 'Outbounds',
            icon: 'fa-arrow-circle-up'
        }
    }, {
        path: '/OutboundsShared',
        name: 'OutboundsShared',
        component: OutboundsShared,
        meta: {
            desc: 'Outbounds Shared',
            icon: 'fa-object-ungroup'
        }
    }, {
        path: '/NoticeOfLoss',
        name: 'NoticeOfLoss',
        component: NoticeOfLoss,
        meta: {
            desc: 'Notice of loss',
            icon: 'fa-chain-broken'
        }
    }, {
        path: '/Transformations',
        name: 'Transformations',
        component: Transformations,
        meta: {
            desc: 'Transformations',
            icon: 'fa-clone'
        }
    }, {
        path: '/Sells',
        name: 'Sells',
        component: Sells,
        meta: {
            desc: 'Sells',
            icon: 'fa-handshake-o'
        }
    }, {
        path: '/Planning',
        name: 'Planning',
        component: Planning,
        meta: {
            desc: 'Planning',
            icon: 'fa-calendar'
        }
    }, {
        path: '/Users',
        name: 'Users',
        component: Users,
        meta: {
            desc: 'Users',
            icon: 'fa-users'
        }
    }, {
        path: '/Roles',
        name: 'Roles',
        component: Roles,
        meta: {
            desc: 'Roles',
            icon: 'fa-id-card-o'
        }
    }, {
        path: '/Settings',
        name: 'Settings',
        component: Settings,
        meta: {
            desc: 'Settings',
            icon: 'fa-cog'
        }
    }, {
        path: '/Printing',
        name: 'Printing',
        component: Printing,
        meta: {
            desc: 'Printing',
            icon: 'fa-print'
        }
    }, {
        path: '/Logs',
        name: 'Logs',
        component: Logs,
        meta: {
            desc: 'Logs',
            icon: 'fa-book'
        }
    }, {
        path: '/Reports',
        name: 'Reports',
        component: Reports,
        meta: {
            desc: 'Reports',
            icon: 'fa-print'
        }
    }, {
        path: '/CompanySettings',
        name: 'Companysettings',
        component: CompanySettings,
        meta: {
            desc: 'Company settings',
            icon: 'fa-cogs'
        }
    }, {
        path: '*',
        redirect: '/'
    }
];

export const router = new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    const publicPages = ['/login'];
    const authRequired = !publicPages.includes(to.path);
    const loggedIn = sessionStorage.getItem('user');
    
    if (authRequired && !loggedIn) {
        return next('/login');
    }
    
    next();
});
